import React, { useState } from 'react';
import { Table, Input, DatePicker, Select, Button, Space, Breadcrumb, Typography, Drawer } from 'antd';
import { getExchanges } from '../../../actions/invoiceItem';
import ExcelDownload from './Excelldownload';

const { RangePicker } = DatePicker;
const { Option } = Select;
const { Text } = Typography;

const RenderTable = ({ data }) => {
    const columns = [
        {
            title: 'Current Invoice Item',
            dataIndex: 'item',
            key: 'item',
            render: (items) => items.map((item, index) => <div key={index}>{index + 1}. {item.Details}{item.brand_name ? `(${item.brand_name})` : ""} | Buy: {item.purchase_price} | Sell: {item.price} | Qty: {item.quantity}</div>)
        },
        {
            title: 'All Invoice Items',
            dataIndex: 'item_copy',
            key: 'item_copy',
            render: (items) => items.map((item, index) => <div key={index}>{index + 1}. {item.Details}{item.brand_name ? `(${item.brand_name})` : ""} | Buy: {item.purchase_price} | Sell: {item.price} | Qty: {item.quantity}</div>)
        },
        {
            title: 'Exchanged',
            dataIndex: 'item_copy',
            key: 'item_copy',
            render: (items) =>
                items
                    .filter((item) => item.is_exchanged)
                    .map((item, index) => <div key={index}>{index + 1}. {item.Details}{item.brand_name ? `(${item.brand_name})` : ""} | Buy: {item.purchase_price} | Sell: {item.price} | Qty: {item.quantity}</div>),
        },

    ];

    return <Table columns={columns} dataSource={[data]} pagination={false} rowKey="id" />;
};

const ExchangeReport = () => {
    const [data, setData] = useState([]);
    const [filters, setFilters] = useState({
        invoice_number: '',
        location: '',
        start: null,
        end: null
    });
    const [loading, setLoading] = useState(false);
    const [totals, setTotals] = useState({ totalBill: 0, totalDiscount: 0, totalPayment: 0, totalAllItems: 0, totalExchanged: 0 });
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);

    const calculateTotals = (data) => {
        const totalBill = data.reduce((sum, invoice) => sum + parseFloat(invoice.bill || 0), 0);
        const totalDiscount = data.reduce((sum, invoice) => sum + parseFloat(invoice.discount || 0), 0);
        const totalPayment = data.reduce((sum, invoice) => sum + parseFloat(invoice.payment || 0), 0);
        const totalAllItems = data.reduce((sum, invoice) => {
            return sum + (invoice.item_copy ? invoice.item_copy.reduce((itemSum, item) => itemSum + (parseFloat(item.price || 0) * parseInt(item.quantity || 1)), 0) : 0);
        }, 0);
        const totalExchanged = data.reduce((sum, invoice) => {
            return sum + (invoice.item_copy ? invoice.item_copy.filter(item => item.is_exchanged).reduce((itemSum, item) => itemSum + (parseFloat(item.price || 0) * parseInt(item.quantity || 1)), 0) : 0);
        }, 0);
        setTotals({ totalBill, totalDiscount, totalPayment, totalAllItems, totalExchanged });
    };

    const handleSearch = async () => {
        setLoading(true);
        try {
            const fetchedData = await getExchanges(filters);
            const filteredData = fetchedData.filter(invoice => 
                invoice.item_copy && invoice.item_copy.some(item => item.is_exchanged)
            );
            setData(filteredData);
            calculateTotals(filteredData);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleFilterChange = (key, value) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            [key]: value
        }));
    };

    const openDrawer = (record) => {
        setSelectedRecord(record);
        setDrawerVisible(true);
    };

    const closeDrawer = () => {
        setDrawerVisible(false);
        setSelectedRecord(null);
    };

    const columns = [
        {
            title: "SL.",
            dataIndex: "index",
            key: "index",
            render: (text, record, index) => index + 1,
        },
        {
            title: 'Invoice',
            dataIndex: 'invoice_number',
            key: 'invoice_number'
        },
        {
            title: 'Location',
            dataIndex: 'location',
            key: 'location',
            render: (location) => location.name || 'N/A',
        },
        {
            title: 'Bill',
            dataIndex: 'bill',
            key: 'bill'
        },
        {
            title: 'Discount',
            dataIndex: 'discount',
            key: 'discount'
        },
        {
            title: 'Payment',
            dataIndex: 'payment',
            key: 'payment'
        },
        {
            title: 'All Items Total',
            key: 'all_items_total',
            render: (_, record) => {
                const total = record.item_copy ? record.item_copy.reduce((sum, item) => sum + (parseFloat(item.price || 0) * parseInt(item.quantity || 1)), 0) : 0;
                return total.toFixed(2);
            }
        },
        {
            title: 'Exchanged Total',
            key: 'exchanged_total',
            render: (_, record) => {
                const total = record.item_copy ? record.item_copy.filter(item => item.is_exchanged).reduce((sum, item) => sum + (parseFloat(item.price || 0) * parseInt(item.quantity || 1)), 0) : 0;
                return total.toFixed(2);
            }
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Button type="link" onClick={() => openDrawer(record)}>
                    View Details
                </Button>
            ),
        },
    ];

    return (
        <>
            <Breadcrumb style={{ margin: "16px 0" }}>
                <Breadcrumb.Item>Exchange Report</Breadcrumb.Item>
            </Breadcrumb>
            <div className="site-layout-background main-frame">
                <Space style={{ marginBottom: 16 }}>
                    <Input
                        placeholder="Invoice Number"
                        onChange={(e) => handleFilterChange('invoice_number', e.target.value)}
                    />
                        <RangePicker
                            onChange={(dates) => {
                                handleFilterChange('start', dates ? dates[0].format('YYYY-MM-DD') : null);
                                handleFilterChange('end', dates ? dates[1].format('YYYY-MM-DD') : null);
                            }}
                        />
                    <Button type="primary" onClick={handleSearch}>
                        Search
                    </Button>
                    <ExcelDownload data={data} />
                </Space>

                {/* Totals Display */}
                {/* <div style={{ marginBottom: 16 }}>
                    <p><b>Total Bill :</b> {totals.totalBill}</p>
                    <p><b>Total Discount :</b> {totals.totalDiscount}</p>
                    <p><b>Total Payment :</b> {totals.totalPayment}</p>
                </div> */}

                <Table 
                columns={columns} 
                dataSource={data} 
                loading={loading} 
                rowKey="id" 
                    summary={(pageData) => {
                        return (
                            <>
                                <Table.Summary.Row>
                                    <Table.Summary.Cell colSpan={3}>
                                        <b>Total</b>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell style={{}} >
                                        <Text>
                                        <b>{totals.totalBill}</b>
                                        </Text>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell >
                                        <Text>
                                        <b>{totals.totalDiscount}</b>
                                        </Text>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell >
                                        <Text>
                                        <b>{totals.totalPayment}</b>
                                        </Text>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell >
                                        <Text>
                                        <b>{totals.totalAllItems.toFixed(2)}</b>
                                        </Text>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell >
                                        <Text>
                                        <b>{totals.totalExchanged.toFixed(2)}</b>
                                        </Text>
                                    </Table.Summary.Cell>
                                    <Table.Summary.Cell >
                                        <Text>
                                        <b></b>
                                        </Text>
                                    </Table.Summary.Cell>

                                    <Table.Summary.Cell colSpan={3}></Table.Summary.Cell>
                                </Table.Summary.Row>
                            </>
                        );
                    }}
                />
                <Drawer
                    title="Exchange Details"
                    width={1000}
                    onClose={closeDrawer}
                    visible={drawerVisible}
                >
                    {selectedRecord && <RenderTable data={selectedRecord} />}
                </Drawer>
            </div>
        </>
    );
};

export default ExchangeReport;
